import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndpoints } from 'src/config/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class GetMakeInvoicesService {

  private apiUrl = ApiEndpoints.invoicedetails;
  private makeInvoiceUrl = ApiEndpoints.ppiinvoicepaymentApiUrl

  constructor(private http: HttpClient) {}

  fetchInvoiceDetails(walletID: string, walletRole: string): Observable<any> {
    const wallettoken = sessionStorage.getItem("walletheaders");
    const sessionID = sessionStorage.getItem("SessionID");
    
    const httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + wallettoken,
        "Content-Type": "application/json"
      }),
    }; 

    // Build the complete body structure expected by the .NET API
    const payload = {
      walletID: walletID,
      walletRole: walletRole,
      sourceSystem: "upsdotcom",
      sessionID: sessionID || "00000000-0000-0000-0000-000000000000", // Fallback if session is null
      payorID: 0,
      policyNumber: "string",
      pageno: "1",
      pagesize: "100"
    };

    return this.http.post<any>(this.apiUrl, payload, httpOptions); 
  }

  // Add this method inside your GetMakeInvoicesService class
    submitInvoicePayment(payload: any): Observable<any> {
      const wallettoken = sessionStorage.getItem("walletheaders");
    
      const httpOptions = {
        headers: new HttpHeaders({
          "Authorization": "Bearer " + wallettoken,
          "Content-Type": "application/json"
        }),
      };

  return this.http.post<any>(this.makeInvoiceUrl, payload, httpOptions);
}
  
}